import type { WorkspaceFolder } from '@carboncopyco/types';
import { Grid } from '@carboncopyco/ui';
import { useLocation } from 'react-router-dom';
import { FolderGridTile } from './Folders';
import { useWorkspacePageProps } from './WorkspacePageContext';

interface WorkspacePageFolderGridProps {
  data: WorkspaceFolder[];
  isArchived?: boolean;
}

export const WorkspacePageFolderGrid = ({
  data,
  isArchived,
}: WorkspacePageFolderGridProps) => {
  const { goToFolderPage, goToArchivedFolderPage } = useWorkspacePageProps();
  const { search } = useLocation();
  return (
    <div className="mb-12">
      <Grid<WorkspaceFolder>
        testDsId="folder-"
        gap="3xl"
        data={data}
        renderItem={(folder) => {
          const { id, workspaceId } = folder;
          return (
            <FolderGridTile
              isArchived={isArchived}
              folder={folder}
              onTileClick={() => {
                isArchived
                  ? goToArchivedFolderPage(id, workspaceId, search)
                  : goToFolderPage(id, workspaceId, search);
              }}
            />
          );
        }}
      />
    </div>
  );
};
